<span *ngIf="enabled"
  [class]="'health-dot-container '+(loading?'loading ':'not-loading ')+(modeLarge?'large':'')+(lockedDetailOpen||detailOpen?' detail-open':'')"
  (click)="lockedDetailOpen=!lockedDetailOpen">
  <span class="health-dot-compact">
    <span class="health-dot-sub-container">
      <span [class]="'health-dot health-dot-1 '+(hubRunning?'health-dot-running':'health-dot-stopped')"></span>
    </span>
    <span class="health-dot-sub-container">
      <span [class]="'health-dot health-dot-2 '+(archiveRunning?'health-dot-running':'health-dot-stopped')"></span>
    </span>
    <span class="health-dot-sub-container">
      <span [class]="'health-dot health-dot-3 '+(allGatewaysRunning?'health-dot-running':'health-dot-stopped')"></span>
    </span>
  </span>
  <span>
    <span class="health-dot-sub-container health-dot-deployed">
      <span [class]="'health-dot health-dot-1 '+(hubRunning?'health-dot-running':'health-dot-stopped')"
            [pTooltip]="(hubRunning?('health.hub-running'|translate):('health.hub-not-running'|translate))"
            tooltipPosition="left">H</span>
      <span [class]="'health-dot health-dot-2 '+(archiveRunning?'health-dot-running':'health-dot-stopped')"
            [pTooltip]="(archiveRunning?('health.archive-running'|translate):('health.archive-not-running'|translate))"
            tooltipPosition="left">A</span>
    </span>
    <span class="health-dot-sub-container health-dot-deployed">
      <span [class]="'health-dot health-dot-3 '+(someGatewaysRunning?'health-dot-running':'health-dot-stopped')"
            [pTooltip]="(allGatewaysRunning?('health.all-gateway-running'|translate)+': '+runningGateways
                  :(someGatewaysRunning?('health.some-gateway-running'|translate)+': '+runningGateways
                  :('health.no-gateway-running'|translate)+': '+notRunningGateways))" tooltipPosition="left">G</span>
      <span [class]="'health-dot health-dot-3 '+(allGatewaysRunning?'health-dot-running':'health-dot-stopped')"
            [pTooltip]="(allGatewaysRunning?('health.all-gateway-running'|translate)+': '+runningGateways
                  :('health.some-gateway-not-running'|translate)+': '+notRunningGateways)" tooltipPosition="left"><i
        class="fa-solid fa-arrow-left"></i></span>
    </span>
  </span>
</span>
<!--<span *ngIf="!loading" class="health-dot-container" (click)="healthOp.toggle($event)">-->
<!--  <span class="health-dot-sub-container">-->
<!--    <span [class]="'health-dot health-dot-1 '+(hubRunning?'health-dot-running':'health-dot-stopped')">H</span>-->
<!--    <span [class]="'health-dot health-dot-2 '+(archiveRunning?'health-dot-running':'health-dot-stopped')">A</span>-->
<!--  </span>-->
<!--  <span class="health-dot-sub-container">-->
<!--    <span [class]="'health-dot health-dot-3 '+(allGatewaysRunning?'health-dot-running':'health-dot-stopped')">G</span>-->
<!--    <span [class]="'health-dot health-dot-3 '+(allGatewaysRunning?'health-dot-running':'health-dot-stopped')">&nbsp;</span>-->
<!--  </span>-->
<!--</span>-->
<!--<p-progressSpinner-->
<!--  *ngIf="loading"-->
<!--  class="cc-spinner-sm" strokeWidth="5"-->
<!--  fill="transparent" animationDuration="0.8s"></p-progressSpinner>-->

